import { Box } from '@chakra-ui/react'
import { ReactNode } from 'react'
import colors from '../../config/theme/colors'

export default function BoxTotal({
    children,
    border = false,
    pt = '4'
}: {
    children: ReactNode
    border?: boolean
    pt?: string
}) {
    return (
        <Box
            display="flex"
            justifyContent="space-between"
            {...(border && {
                borderTop: `1px solid ${colors['alo-gray']}`,
                pt: pt
            })}
            fontWeight="bold"
        >
            {children}
        </Box>
    )
}
